export const ProductInfoModuleName = 'Product Info Banner';
